import { html, TemplateResult, CSSResultGroup, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotsNGController as SlotsController } from '../../controllers/slots-ng-controller';
import '../sic-container/sic-container';
import componentStyles from './sic-global-alert.css.lit';
import defaultVars from './css-variables/sic-global-alert-vars.css.lit';
import {
  screenSizeMap,
  ScreenSizeController,
} from '../../controllers/screen-size-controller';
export type Status = 'success' | 'error' | 'info' | 'warning';
/**
 * This is will be also be used for the page alerts
 *
 * @element sic-global-alert
 * @slot title - slot for heading
 * @slot body - slot for body WYSIWYG
 * @slot body-secondary - slot for secondary body content (right side)
 * @slot icon - slot for changeable icon
 * @slot closing - slot for dismissible X
 * @prop status - reflects status of alert
 * @prop rightContent - if right content is needed
 * @prop is-inpage - reflects if alert is global or page
 */

@customElement('sic-global-alert')
export class SicGlobalAlert extends OutlineElement {
  slots = new SlotsController(this);
  screens = new ScreenSizeController(this);

  static styles: CSSResultGroup = [
    OutlineElement.styles,
    defaultVars,
    componentStyles,
    css``,
  ];

  @property({ type: String, attribute: 'breakpoint' })
  visibleBreakpoint = 'md';

  @property()
  status: Status = 'success';
  /**
   * This property is used to determine if the alert is global alert or an on page alert.
   * It provides a default value false, which means that is a global alert.
   */
  @property({ type: Boolean, attribute: 'is-inpage' })
  isInPage = false;
  @property({ type: Boolean, attribute: 'right-content' })
  rightContent = false;

  render(): TemplateResult {
    const isMobile =
      window.innerWidth < (screenSizeMap.get(this.visibleBreakpoint) as number);

    if (isMobile) {
      return html` <sic-container
        class="${this.status}"
        top-padding="none"
        bottom-padding="none"
        x-padding="${this.isInPage ? 'none' : 'normal'}"
      >
        <div class="${this.isInPage ? 'is-inpage' : 'container'}">
          <div class="mobile-icons">
            ${this.slots.conditionalSlot('icon', false)}
            ${this.slots.conditionalSlot('closing', false)}
          </div>
          <div class="content">

            <div class="body-wrapper">
                <div class="body-primary">
                  ${this.slots.conditionalSlot('title', false)}
                  ${this.slots.conditionalSlot('body', false)}
                </div>
                ${this.rightContent
              ? html`<div class="body-secondary">
                  ${this.slots.conditionalSlot('body-secondary', false)}
                </div>`
              : ''}
                </div>
              </div>
          </div>
        </div>
      </sic-container>`;
    } else {
      return html`
        <sic-container
          class="${this.status}"
          top-padding="none"
          bottom-padding="none"
          x-padding="${this.isInPage ? 'none' : 'normal'}"
        >
          <div class="${this.isInPage ? 'is-inpage' : 'container'}">

            <div class="content ${this.rightContent ? 'has-right-content' : ''}">
              ${this.slots.conditionalSlot('icon', false)}
              <div class="body-wrapper ${this.rightContent ? 'has-right-content' : ''}">
                <div class="body-primary">
                  ${this.slots.conditionalSlot('title', false)}
                  ${this.slots.conditionalSlot('body', false)}
                </div>
                ${this.rightContent
              ? html`<div class="body-secondary">
                  ${this.slots.conditionalSlot('body-secondary', false)}
                </div>`
              : ''}
              </div>
            </div>

            <div class="closing-wrapper">
              ${this.slots.conditionalSlot('closing', false)}
            </div>
          </div>
        </sic-container>
      `;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-global-alert': SicGlobalAlert;
  }
}
